import { render, staticRenderFns } from "./CategoriaCard.vue?vue&type=template&id=54d098f6&scoped=true"
import script from "./CategoriaCard.vue?vue&type=script&lang=js"
export * from "./CategoriaCard.vue?vue&type=script&lang=js"
import style0 from "./CategoriaCard.vue?vue&type=style&index=0&id=54d098f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d098f6",
  null
  
)

export default component.exports